import {
  Button,
  Card,
  Col,
  Input,
  Row,
  Select,
  Table,
  DatePicker,
  message,
  Radio,
  Spin,
  Modal,
  Form,
  Checkbox,
} from "antd";
import { Component } from "react";
import moment from "moment";
import locale from "./../../constants/locale.json";
import "./TicketLog.css";
const { Option } = Select;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};
const columns = [
  {
    title: "Date IN",
    dataIndex: "start_time",
    align: "center",
    render: (_, row) => {
      return <>{row.start_time_fmt}</>;
    },
    sorter: (a, b) => (a.start_time || "").localeCompare(b.start_time || ""),
  },
  {
    title: "Date OUT",
    dataIndex: "end_time",
    align: "center",
    render: (_, row) => {
      return <>{row.end_time_fmt || "-"}</>;
    },
    sorter: (a, b) => (a.end_time || "").localeCompare(b.end_time || ""),
  },
  {
    title: "Ticket #",
    dataIndex: "barcode",
    align: "center",
    sorter: (a, b) => (a.barcode || "").localeCompare(b.barcode || ""),
  },
  {
    title: "Type",
    dataIndex: "is_lost_ticket",
    ellipsis: true,
    align: "center",
    render: (is_lost_ticket, row) => {
      const { is_moto, is_car } = row;
      if (is_lost_ticket) {
        return <>{`Lost (${is_car ? "Car" : "Moto"})`}</>;
      } else if (is_car) {
        return <>{"Car"}</>;
      } else if (is_moto) {
        return <>{"Moto"}</>;
      } else {
        return <>{" Unknown"}</>;
      }
    },
  },
  {
    title: "Rate Name",
    dataIndex: "rate_type_name",
    align: "center",
  },
  {
    title: "Duration",
    dataIndex: "duration_hr",
    ellipsis: true,
    align: "center",
    render: (_, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      const { duration_hour, duration_min } = row;
      const durationHourFmt =
        row.duration_hour >= 10 ? `${duration_hour}` : `0${duration_hour}`;
      const durationMinFmt =
        row.duration_min >= 10 ? `${duration_min}` : `0${duration_min}`;

      return <>{`${durationHourFmt}:${durationMinFmt}`}</>;
    },
  },
  {
    title: "Amount (Riel)",
    dataIndex: "amount",
    align: "center",
    render: (amount, row) => {
      if (!row.end_time) {
        return <>-</>;
      }
      return <>{amount}</>;
    },
  },
  {
    title: "Gate IN",
    dataIndex: "in_gate_display_name",
    align: "center",
    render: (in_gate_display_name, row) => {
      return (
        <>
          {row.is_lost_ticket || !in_gate_display_name
            ? "-"
            : in_gate_display_name}
        </>
      );
    },
  },
  {
    title: "Gate OUT",
    dataIndex: "out_gate_display_name",
    align: "center",
    render: (out_gate_display_name) => {
      return <>{out_gate_display_name || "-"}</>;
    },
  },
  {
    title: "Processed By",
    dataIndex: "username",
    align: "center",
  },
];

const options = [
  { label: "PDF", value: "pdf" },
  { label: "Excel", value: "xlsx" },
];

export default class TicketLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      exportType: null,
      isExportModalVisible: false,
      isLoading: false,
      filterDateTimeInStart: null,
      filterDateTimeInEnd: null,
      filterDateTimeOutStart: null,
      filterDateTimeOutEnd: null,
      filterTicketNumber: null,
      filterUserName: null,
      filterInGateIds: [],
      filterOutGateIds: [],
      filterRateTypeIds: [],
      inGates: [],
      outGates: [],
      exportDateStart: null,
      exportDateEnd: null,
      exportIncludeImage: false,
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    fetch(`/api/v1/report/ticket/bundle`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        const { inGates, outGates } = data;
        this.setState({
          inGates,
          outGates,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  onInputFieldChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      logs: [],
      [name]: value,
    });
  };

  onFieldChange = (name, value) => {
    this.setState({
      logs: [],
      [name]: value,
    });
  };

  onSearchClick = () => {
    const { accessToken } = this.props;
    const {
      filterDateTimeInStart,
      filterDateTimeInEnd,
      filterDateTimeOutStart,
      filterDateTimeOutEnd,
      filterTicketNumber,
      filterUserName,
      filterInGateIds,
      filterOutGateIds,
      filterRateTypeIds,
    } = this.state;
    this.setState({
      logs: [],
      isLoading: true,
    });
    return fetch(`/api/v1/report/ticket/list`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        filterDateTimeInStart,
        filterDateTimeInEnd,
        filterDateTimeOutStart,
        filterDateTimeOutEnd,
        filterTicketNumber,
        filterUserName,
        filterInGateIds,
        filterOutGateIds,
        filterRateTypeIds,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        const { logs } = data;
        if (logs.length === 0) {
          message.warning("No logs returned!");
        }
        return this.setState({
          logs,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onClearClick = () => {
    this.setState({
      logs: [],
      filterDateTimeInStart: null,
      filterDateTimeInEnd: null,
      filterDateTimeOutStart: null,
      filterDateTimeOutEnd: null,
      filterTicketNumber: null,
      filterUserName: null,
      filterInGateIds: [],
      filterOutGateIds: [],
      filterRateTypeIds: [],
    });
  };

  isFiltered = () => {
    const {
      filterDateTimeInStart,
      filterDateTimeInEnd,
      filterDateTimeOutStart,
      filterDateTimeOutEnd,
      filterTicketNumber,
      filterUserName,
      filterInGateIds,
      filterOutGateIds,
      filterRateTypeIds,
    } = this.state;
    return (
      !!filterDateTimeInStart ||
      !!filterDateTimeInEnd ||
      !!filterDateTimeOutStart ||
      !!filterDateTimeOutEnd ||
      !!filterTicketNumber ||
      !!filterUserName ||
      (!!filterInGateIds && filterInGateIds.length > 0) ||
      (!!filterOutGateIds && filterOutGateIds.length > 0) ||
      (!!filterRateTypeIds && filterRateTypeIds.length > 0)
    );
  };

  getReport = (reportType) => {
    const { accessToken } = this.props;
    const { exportDateStart, exportDateEnd, exportIncludeImage } = this.state;

    this.setState({
      isLoading: true,
    });
    fetch(`/api/v1/report/ticket/download/${reportType}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        startDate: exportDateStart,
        endDate: exportDateEnd,
        includeImage: exportIncludeImage,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.blob();
      })
      .then((blob) => {
        const filename = moment(new Date()).format("YYYYMMDDHHmmss");
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}_TicketLogReport.${reportType}`;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
        message.success("Ticket Log Exported Successfully!");
        this.setState({
          isExportModalVisible: false,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  isValidExportDateRange = (startDate, endDate, showMessage = false) => {
    if (!startDate || !endDate) {
      return false;
    }

    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);

    if (startDateObj > endDateObj) {
      return false;
    }
    const timeDifference = endDateObj.getTime() - startDateObj.getTime();
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    if (daysDifference <= 31) {
      return true;
    }

    if (showMessage) {
      message.warn("Date range cannot be more than 31 days");
    }

    return false;
  };

  render() {
    const {
      logs,
      exportType,
      isExportModalVisible,
      isLoading,
      filterDateTimeInStart,
      filterDateTimeInEnd,
      filterDateTimeOutStart,
      filterDateTimeOutEnd,
      filterTicketNumber,
      filterUserName,
      filterInGateIds,
      filterOutGateIds,
      filterRateTypeIds,
      inGates,
      outGates,
      exportDateStart,
      exportDateEnd,
      exportIncludeImage,
    } = this.state;
    const { currentLang } = this.props;
    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">Report </div>
            <div className="page-header-sub">Ticket Log</div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row
              style={{ margin: 0 }}
              className="visitor-history-search-wrapper"
            >
              <Col
                flex="900px"
                className="visitor-detail-group"
                style={{ padding: "0px" }}
              >
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Date IN
                      </span>
                      <DatePicker
                        style={{ width: "100%" }}
                        showToday={false}
                        placeholder="Start"
                        format="DD/MM/YYYY HH:mm"
                        value={filterDateTimeInStart}
                        showTime={true}
                        onChange={(evt) => {
                          let newFilterDateTimeInEnd =
                            filterDateTimeInEnd < evt
                              ? undefined
                              : filterDateTimeInEnd;
                          this.setState({
                            logs: [],
                            filterDateTimeInStart: evt,
                            filterDateTimeInEnd: newFilterDateTimeInEnd,
                          });
                        }}
                      />
                    </Input.Group>
                  </Col>
                  <Col style={{ width: "5px" }} />
                  <Col span={10}>
                    <DatePicker
                      style={{ width: "100%" }}
                      showToday={false}
                      value={filterDateTimeInEnd}
                      placeholder="End"
                      format="DD/MM/YYYY HH:mm"
                      showTime={true}
                      onChange={(evt) => {
                        let newFilterDateTimeInStart =
                          filterDateTimeInStart > evt
                            ? undefined
                            : filterDateTimeInStart;
                        this.setState({
                          logs: [],
                          filterDateTimeInStart: newFilterDateTimeInStart,
                          filterDateTimeInEnd: evt,
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Date OUT
                      </span>
                      <DatePicker
                        style={{ width: "100%" }}
                        showToday={false}
                        placeholder="Start"
                        format="DD/MM/YYYY HH:mm"
                        value={filterDateTimeOutStart}
                        showTime={true}
                        onChange={(evt) => {
                          let newFilterDateTimeOutEnd =
                            filterDateTimeOutEnd < evt
                              ? undefined
                              : filterDateTimeOutEnd;
                          this.setState({
                            logs: [],
                            filterDateTimeOutStart: evt,
                            filterDateTimeOutEnd: newFilterDateTimeOutEnd,
                          });
                        }}
                      />
                    </Input.Group>
                  </Col>
                  <Col style={{ width: "5px" }} />
                  <Col span={10}>
                    <DatePicker
                      style={{ width: "100%" }}
                      showToday={false}
                      value={filterDateTimeOutEnd}
                      placeholder="End"
                      format="DD/MM/YYYY HH:mm"
                      showTime={true}
                      onChange={(evt) => {
                        let newFilterDateTimeOutStart =
                          filterDateTimeOutStart > evt
                            ? undefined
                            : filterDateTimeOutStart;
                        this.setState({
                          logs: [],
                          filterDateTimeOutStart: newFilterDateTimeOutStart,
                          filterDateTimeOutEnd: evt,
                        });
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input
                      addonBefore="Ticket"
                      placeholder="Number"
                      type="number"
                      name="filterTicketNumber"
                      value={filterTicketNumber}
                      onChange={this.onInputFieldChange}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Rate
                      </span>
                      <Select
                        placeholder="Type"
                        className="group-addon-input"
                        value={filterRateTypeIds}
                        onChange={(val) =>
                          this.setState({
                            logs: [],
                            filterRateTypeIds: val,
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                        style={{ width: "100%" }}
                        maxTagCount="responsive"
                      >
                        <Option key={1} value={1}>
                          Moto
                        </Option>
                        <Option key={2} value={2}>
                          Car
                        </Option>
                        <Option key={3} value={3}>
                          Lost (Moto)
                        </Option>
                        <Option key={4} value={4}>
                          Lost (Car)
                        </Option>
                      </Select>
                    </Input.Group>
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input.Group
                      compact
                      className="group-compact-select-wrapper"
                    >
                      <span className="ant-input-group-addon group-addon-label">
                        Gate
                      </span>
                      <Select
                        placeholder="IN"
                        className="group-addon-input"
                        value={filterInGateIds}
                        onChange={(val) =>
                          this.setState({
                            logs: [],
                            filterInGateIds: val,
                          })
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                        style={{ width: "100%" }}
                        maxTagCount="responsive"
                      >
                        {inGates.map((gt) => {
                          return (
                            <Option key={gt.id} value={gt.id}>
                              {gt.display_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Input.Group>
                  </Col>
                  <Col style={{ width: "5px" }} />
                  <Col span={10}>
                    <Select
                      placeholder="OUT"
                      className="group-addon-input"
                      value={filterOutGateIds}
                      onChange={(val) =>
                        this.setState({
                          logs: [],
                          filterOutGateIds: val,
                        })
                      }
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      mode="multiple"
                      style={{ width: "100%" }}
                      maxTagCount="responsive"
                    >
                      {outGates.map((gt) => {
                        return (
                          <Option key={gt.id} value={gt.id}>
                            {gt.display_name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                  <Col span={12}>
                    <Input
                      addonBefore="Processed By"
                      placeholder="Username"
                      name="filterUserName"
                      value={filterUserName}
                      onChange={this.onInputFieldChange}
                    />
                  </Col>
                </Row>
                <div className="visitor-action-group">
                  <Button
                    type="primary"
                    style={{ marginRight: "15px", width: "120px" }}
                    disabled={isLoading}
                    onClick={this.onSearchClick}
                  >
                    {locale.app.common.search[currentLang]}
                  </Button>
                  <Button
                    style={{ marginRight: "15px", width: "120px" }}
                    disabled={!this.isFiltered()}
                    onClick={this.onClearClick}
                  >
                    {locale.app.common.reset[currentLang]}
                  </Button>
                  <Button
                    style={{ marginRight: "15px", width: "120px" }}
                    onClick={() => {
                      this.setState({
                        isExportModalVisible: true,
                        exportType: null,
                        exportDateStart: null,
                        exportDateEnd: null,
                        exportIncludeImage: false,
                      });
                    }}
                  >
                    {locale.app.common.export[currentLang]}
                  </Button>
                </div>
              </Col>
            </Row>
            <Row style={{ margin: 0 }}>
              <div className="table-section-header">Ticket Log</div>
              <Table
                rowKey="id"
                style={{ overflow: "auto", width: "100%" }}
                columns={columns}
                dataSource={logs}
                size="small"
                scroll={{ x: "max-content" }}
              />
            </Row>
          </Spin>
        </Card>
        <Modal
          title={"Export Ticket Log"}
          closable={false}
          visible={isExportModalVisible}
          onOk={() => {
            if (exportType) {
              this.getReport(exportType);
            }
          }}
          onCancel={() => {
            this.setState({
              isExportModalVisible: false,
            });
          }}
          okButtonProps={{
            disabled:
              !exportType ||
              isLoading ||
              !exportDateStart ||
              !exportDateEnd ||
              !this.isValidExportDateRange(exportDateStart, exportDateEnd),
          }}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <Form
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
          >
            <Form.Item
              label="Start Date"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showToday={false}
                placeholder=" "
                format="DD/MM/YYYY"
                value={exportDateStart}
                onChange={(evt) => {
                  this.isValidExportDateRange(evt, exportDateEnd, true);
                  this.setState({
                    exportDateStart: evt,
                  });
                }}
              />
            </Form.Item>
            <Form.Item
              label="End Date"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                showToday={false}
                placeholder=" "
                format="DD/MM/YYYY"
                value={exportDateEnd}
                onChange={(evt) => {
                  this.isValidExportDateRange(exportDateStart, evt, true);
                  this.setState({
                    exportDateEnd: evt,
                  });
                }}
              />
            </Form.Item>
            <Form.Item
              label="Format"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Radio.Group
                options={options}
                onChange={(e) => {
                  this.setState({
                    exportType: e.target.value,
                  });
                }}
                value={exportType}
              />
            </Form.Item>

            <Form.Item label="Include Image PDF">
              <Checkbox
                checked={exportIncludeImage}
                onChange={(e) => {
                  this.setState({ exportIncludeImage: e.target.checked });
                }}
              ></Checkbox>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}
